import {unitsModule} from "../../unitsModule";
import {LoadingService} from "../../../../bower_components/front-end-web-commons";
import {IDeferred, IHttpService, IQService, IScope} from "angular";
import userManagementServer from "../../../userManagementServer";

interface TabUsersScope extends IScope {
    permissionGroupId: number
}

class TabUsers {
    paginationApi: IDeferred<any>;
    tableOptions: any = {}
    isUnityPermissionGroup: boolean

    constructor(private $scope: TabUsersScope,
                private loadingService: LoadingService,
                private $http: IHttpService,
                private $q: IQService) {

        this.configureTableOptions();
        this.isUnityPermissionGroup = !!$scope.permissionGroupId
    }

    private configureTableOptions() {
        this.paginationApi = this.$q.defer();
        let self = this;
        let permissionGroupId = this.$scope.permissionGroupId
        this.tableOptions = {
            records: [],
            pagination: {
                onPaginate: function (firstResult = 0, maxResults = 10) {
                    return self.loadingService(
                        self.getPermissionGroups(permissionGroupId, firstResult, maxResults).then((response: any) => {
                            return response.data;
                        }));
                }
            },
            onRegisterPagination: function (api) {
                self.paginationApi = api;
                api.seekPage(1);
            }
        }
    }

    private getPermissionGroups(permissionGroupId: number, firstResult: number, maxResults: number) {
        let serviceURL = permissionGroupId ? userManagementServer.getServiceUrl("permission-group-unities-users") : userManagementServer.getServiceUrl("permission-group-company-unities-users");
        return this.$http.post(serviceURL, null, {
            params: {
                permissionGroupId,
                firstResult,
                maxResults
            }
        });
    }

    isEmptyRecords() {
        let tableOptions = this.tableOptions
        if (!tableOptions) {
            return false;
        }
        return tableOptions.records.length === 0
    }
}

export const directive = unitsModule.directive("tabUsers", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./tabUsers.html"),
        scope: {
            onRegisterApi: "=",
            permissionGroupId: "<?"
        },
        controllerAs: "ctrl",
        controller: TabUsers
    }
}])